module.exports = __webpack_public_path__ + "img/Complex-Falafel.23db4825.png";